let sizer_theme = null;
let sizer_color = null;

export function getTheme(){
    if(sizer_theme){
        return sizer_theme;
    }else{
        const urlQuery = new URLSearchParams(document.location.search)
        let theme = urlQuery.get('wl');
        let path = window.location.pathname;
        if (path.includes('vendor/barrier')){
          sizer_theme = 'barrier';
          return sizer_theme;
        }
        switch (theme) {
          case 'barrier':
            sizer_theme = 'barrier';
            break;
        
          case 'pcami':
            sizer_theme = 'pcami';
            break;
          
          default:
            sizer_theme = 'default';
            break;
        }
        return sizer_theme;

    }
}

export function getButtonThemeColor(){
  if(sizer_color){
    return sizer_color;
  }else{
      switch (getTheme()) {
        case 'barrier':
          sizer_color = '#015295';
          break;
      
        case 'pcami':
          sizer_color = '#1353B4';
          break;
        
        default:
          sizer_color = '#988FFF';
          break;
      }
      return sizer_color;

  }
}